import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import { Set as ImmutableSet } from 'immutable';
export const getIscTeamIds = () => enviro.isQa() ? ImmutableSet.of(129906, 282289) : ImmutableSet.of(31994, 280866, 280868, 280869);
export const getIscSupportedHubId = () => enviro.isQa() ? 99535353 : 53;
export const getIsIscHub = () => PortalIdParser.get() === getIscSupportedHubId();